export default "__VITE_ASSET__Bzsst9K5__"